/*=========================================================================================
	File Name: moduleAuthMutations.js
	Description: Auth Module Mutations
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
	MPNAME_LIST(state, value) {
		state.MpNameList = value;
	},
	COMPLETED_ORDER_LIST(state, value) {
		state.CompletedOrder = value;
	},
	ORDER_LIST(state, value) {
		state.Order = value;
	}, ORDER_COLLECT_HEAD(state, value) {
		state.OrderCollectHead = value;
	}, ORDER_COLLECT_ITEM(state, value) {
		state.OrderCollectItem = value;
	},
}
